import { CommonModule } from '@angular/common'
import { formatDate } from '@angular/common'
import { Component, effect, inject } from '@angular/core'
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'

import { Store } from '@ngrx/store'
import moment from 'moment'
import { DialogModule } from 'primeng/dialog'
import { ImageModule } from 'primeng/image'
import { ProgressBarModule } from 'primeng/progressbar'
import { TooltipModule } from 'primeng/tooltip'

import { AiSelectors } from '@flowx/designer/modules/new-ai/store/ai.selectors'

@Pipe({
  name: 'flxLogDateFormat',
  standalone: true,
})
export class FlxLogDateFormatPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(input: any): string {
    if (!input) {
      return '-'
    }
    const date = formatDate(input, 'dd-MM-yyyy', this.locale)
    const time = formatDate(input, 'HH:mm:ss', this.locale)
    return `${date} ${time}`
  }
}

@Component({
  selector: 'flx-ai-agent-log',
  imports: [
    CommonModule,
    DialogModule,
    ImageModule,
    ProgressBarModule,
    TooltipModule,
    FlxLogDateFormatPipe,
  ],
  templateUrl: './agent-log.component.html',
  styleUrls: ['./agent-log.component.scss'],
  standalone: true,
})
export class AgentLogComponent {
  #store = inject(Store)

  logs = this.#store.selectSignal(AiSelectors.logs)

  getIconByType(type: string): string {
    switch (type) {
      case 'node':
        return 'ph pt-1 text-yellow-500 ph-tree-structure font-bold'
      case 'action':
        return 'ph pt-1 text-yellow-500 ph-code font-bold'
      case 'ui':
        return 'ph pt-1 text-yellow-500 ph-layout font-bold'
      case 'datamodel':
        return 'ph pt-1 text-yellow-500 ph-database font-bold'
      default:
        return 'document'
    }
  }
  updateElapsedTime(timestamp: string): string {
    const now = moment()
    const pastTime = moment(timestamp)

    // Example: Display exact time difference in years, months, days, hours, and minutes
    return `${pastTime.fromNow(true)} (${now.diff(pastTime, 'minutes') % 60} minutes, ${now.diff(pastTime, 'seconds') % 60} seconds ago)`
  }
}
